export default __webpack_public_path__ + "static/media/optionsIcon.4282bf08.svg";